<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ backgroundColor }">
        <path
            d="M34 10H6C3.8 10 2 11.78 2 14V32H6C6 35.32 8.68 38 12 38C15.32 38 18 35.32 18 32H30C30 35.32 32.68 38 36 38C39.32 38 42 35.32 42 32H46V22L34 10ZM30 14H32L38 20H30V14ZM18 14H26V20H18V14ZM6 14H14V20H6V14ZM12 34.5C10.62 34.5 9.5 33.38 9.5 32C9.5 30.62 10.62 29.5 12 29.5C13.38 29.5 14.5 30.62 14.5 32C14.5 33.38 13.38 34.5 12 34.5ZM36 34.5C34.62 34.5 33.5 33.38 33.5 32C33.5 30.62 34.62 29.5 36 29.5C37.38 29.5 38.5 30.62 38.5 32C38.5 33.38 37.38 34.5 36 34.5ZM42 28H40.44C39.34 26.78 37.76 26 36 26C34.24 26 32.66 26.78 31.56 28H16.44C15.34 26.78 13.78 26 12 26C10.22 26 8.66 26.78 7.56 28H6V24H42V28Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
